import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EmpresaDetalharComponent } from './empresa-detalhar.component';




@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: EmpresaDetalharComponent }    
    ])],
    exports: [RouterModule]
})
export class EmpresaDetalharRoutingModule { }
